import { mapperModuleNavigationLink } from '../../../core/data-layer/modules/mappers'
import { mapperNews } from '../../../core/data-layer/mappers'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page press and media newsroom mapper
 * normalizes data to be used in pages

 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  const headerPrimaryLink = data?.headerPrimaryLink
    ? {
        ...mapperModuleNavigationLink(data.headerPrimaryLink, options.getUrl),
        type: 'button'
      }
    : null
  const headerSecondaryLink = data?.headerSecondaryLink
    ? {
        ...mapperModuleNavigationLink(data.headerSecondaryLink, options.getUrl),
        iconRight: { category: 'arrows', name: 'chevron-right-small' },
        theme: 'light'
      }
    : null

  const categories = {
    commercial: data.categoryCommercial || '',
    investor_relations: data.categoryInvestorRelations || ''
  }
  return {
    headerLinks: [headerPrimaryLink, headerSecondaryLink].filter(Boolean),
    filtersRegionPlaceholder: data.filtersRegionPlaceholder || '',
    filtersCategoryPlaceholder: data.filtersCategoryPlaceholder || '',
    filtersYearPlaceholder: data.filtersYearPlaceholder || '',
    noResultsFound: data.noResultsFound || '',
    categories,
    news: mapperNews(data?.news, options, categories).filter((item) => Boolean(item?.link?.url)) || [],
    pageContentComponentName: 'PageContentNewsroom'
  }
}
